import React from 'react'
import { Grid, Typography, Button } from '@mui/material'
import { connect } from 'react-redux'
import * as common from '../../appRedux/actions/common'
import LoginImage from '../../assets/images/login.png'
import IntlMessages from '../../util/IntlMessages'
import * as router from '../../constants/router'
import useStyles from './styles'

function ErrorPage(props) {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Grid className={classes.root}>
                <Grid className={classes.gridImage}>
                    <img
                        data-testid="img-attribute"
                        src={LoginImage}
                        alt={<IntlMessages id="alt.main" />}
                        className={classes.image} />
                </Grid>
                <Grid className={classes.content}>
                    <Typography
                        data-testid="title-content"
                        variant="h5"
                        className={classes.typographyTitle} >
                        {props.title}
                    </Typography>
                    <Typography data-testid="message-content">
                        {props.message}
                    </Typography>
                    <Button
                        onClick={() => props.redirectAction(router.HOME)}
                        variant="text"
                        color="secondary"
                    >
                        <IntlMessages id="comeback" />
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment >
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (data) => dispatch(common.redirectAction(data)),
    }
}

export default connect(null, mapDispatchToProps)(ErrorPage)
